import produce from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import { RootModel } from '../models';
import { storeName as sharedFilterResultEntityStore } from '../entities/sharedFilterResult.entity';
import { DEFAULT_PAGINATION } from '../../commons/constants';
import { PageRequest, PaginationResponseTypes, PaginationTypes } from '../../types/response';

export const storeName = 'sharedFilterResultModel';

export interface SharedResultFilterCriteria {
  keyword?: string;
}

type PropertiesModelTypes = {
  codes: string[];
  loading: boolean;
  pagination: PaginationTypes;
  criteria: SharedResultFilterCriteria;
};

const initialState: PropertiesModelTypes = {
  codes: [],
  loading: false,
  pagination: DEFAULT_PAGINATION,
  criteria: { keyword: '' },
};

export const sharedFilterResultModel: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    setCodes: produce((state, payload: string[]) => {
      state.codes = payload;
    }),
    setLoading: produce((state, payload: boolean) => {
      state.loading = payload;
    }),
    setPagination: produce((state, payload: PaginationTypes) => {
      state.pagination = payload;
    }),
    setCriteria: produce((state, payload) => {
      state.criteria = payload;
    }),
  },
  effects: (dispatch: RematchDispatch<any>) => ({
    async fetch(payload = {}, state) {
      this.setLoading(true);

      const { pagination = state[storeName].pagination } = payload;
      const resp: PaginationResponseTypes<any> = await dispatch[
        sharedFilterResultEntityStore
      ].fetchSharedFilterResult({
        ...pagination,
        ...payload,
      });

      const { data } = resp;
      if (data && !!data.content) {
        this.setCodes(data.content.map((i) => i.code));
      }

      this.setPagination((({ content, ...otherProps }) => otherProps)(data));

      this.setLoading(false);
    },

    async pagingAsync(payload: PageRequest, state) {
      if (state[storeName].loading) return;

      this.setLoading(true);
      const { criteria = {}, pagination = {} } = state[storeName];
      await this.fetch({ ...criteria, ...pagination, ...payload });
    },

    async deleteAsync(payload: string, state) {
      if (!payload) return;

      this.setLoading(true);
      const result = await dispatch[sharedFilterResultEntityStore].deleteSharedFilterResult(
        payload
      );

      if (result) this.fetch();
    },

    async retryAsync(payload, state) {
      if (!payload) return;

      this.setLoading(true);
      const result = await dispatch[sharedFilterResultEntityStore].retrySharedFilterResult(payload);

      if (result) this.fetch();
    },
  }),
});

export default sharedFilterResultModel;
